module.exports = __webpack_public_path__ + "img/chipin-outline.02385d8f.svg";